export default __webpack_public_path__ + "static/media/AnimalMondey02_03.6bca705a.png";